<template>
  <div class="container-fluid" id="notapplicable-step">
    <img
      :src="`${useAsset('img/credit-line/no_cl_offer.svg')}`"
      class="mx-auto d-block"
      alt="sorryno"
    />
    <h2 class="text-center mt-3 text-black">{{ t("DEVICENOTQUALIFIED") }}</h2>
    <div id="other-offer-card" class="mt-4">
      <p v-if="errorCode">{{ t(`CL_ERROR_CODES.${errorCode}`) }}</p>
      <p v-else>{{ t("ELIGIBLEFOROTHER") }}</p>
      <br />
      <p class="mb-1 text-center">
        {{ t("DEVICE_TAG_CL_HELP", { deviceTag: deviceIdentifier }) }}
      </p>
    </div>
    <div class="position-fixed bottom-0 mt-3 mb-5 w-85 end-0 start-0 mx-auto">
      <div class="text-center mt-3">
        <a href="javascript:;" @click="callSupport()" class="call-support-link">
          {{ t("CALL") }}
        </a>
      </div>
      <Button class="fw-bold mb-0 flex-fill mt-3 px-3 py-2" @click="goToHome">
        {{ t("CREDIT_LINE_FEEDBACK.GO_TO_HOME") }}
      </Button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import Button from "@/apps/credit-line/components/Button.vue";
import {
  AvailableFeatures,
  FeatureControlService,
} from "@/apps/credit-line/services/feature-control.service";
import { getCookieHelper } from "@/shared-helpers/get-cookie.helper";
declare const Android: AndroidInterface;
export default defineComponent({
  name: "RegistrationNotApplicable",
  components: { Button },
  props: {
    inStore: Boolean,
    person_uuid: String,
    errorCode: Number,
  },
  methods: { useAsset },
  setup(props) {
    const { t } = useI18n();
    const FeatureControl = new FeatureControlService();
    const deviceIdentifier = computed(() =>
      props.inStore ? props.person_uuid : Android.getDeviceTag()
    );

    const callSupport = () => {
      logAnalyticsEvent(AnalyticEvents.CreditLine.ContactMoreOptions, "Offer");
      const helpMsg = t("CL_WP_HELP_MSG", {
        deviceTag: deviceIdentifier.value,
      });
      const country = getCookieHelper("country");
      const waNumber = FeatureControl.getFeatureValue(
        AvailableFeatures.WHATSAPP,
        country as string,
        "number"
      );
      window.open(`https://wa.me/${waNumber}?text="${helpMsg}`, "_system");
    };

    const goToHome = () => {
      if (props.inStore) {
        Android.kycFinished("");
      } else {
        logAnalyticsEvent(
          AnalyticEvents.CreditLine.ClickNotInterested,
          "Offer",
          "User declines offer"
        );
        Android.creditOfferIneligible();
      }
    };

    return {
      t,
      deviceIdentifier,
      goToHome,
      callSupport,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

#other-offer-card {
  padding: 5%;
  background-color: transparent;

  & p:first-of-type {
    color: #111;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;

    /* text-regular */
    font-family: Nunito;
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem; /* 160% */
  }
}

.call-support-link {
  font-weight: 600;
  font-size: 1rem;
  font-style: italic;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.24px;
  color: $pj-color-green !important;
  text-decoration: none;
}

.Button {
  display: flex;
  align-items: center;
  gap: -0.1875rem;
  flex-shrink: 0;
  height: 2.75rem;
  padding: 0.625rem 1.5rem;
  justify-content: space-between;
}

.w-85 {
  width: 85%;
}
</style>
